/*
 * Everlast · Arma tu equipo — mejora progresiva (WAY A — NATIVO BALANCE)
 * Intercepta el formulario nativo de cada accesorio, lo agrega al carrito vía
 * fetch (/cart/add.js), refresca el ícono/drawer nativo con el evento
 * 'cart:update' del tema y, si algo falla o no hay drawer, cae a /cart.
 * Sin JS, el formulario nativo sigue funcionando (POST /cart/add → /cart).
 */
(function () {
  'use strict';

  function sectionsToRefresh() {
    var ids = [];
    document
      .querySelectorAll('cart-drawer-component[data-section-id], cart-items-component[data-section-id], cart-icon[data-section-id]')
      .forEach(function (el) {
        if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) {
          ids.push(el.dataset.sectionId);
        }
      });
    return ids.join(',');
  }

  function announce(name) {
    var live = document.querySelector('[data-ev-live]');
    if (live) live.textContent = (name || 'Accesorio') + ' agregado al carrito.';
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-ev-form]')) return;
    event.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var data = new FormData(form);
    var id = parseInt(data.get('id'), 10);
    var qty = parseInt(data.get('quantity') || '1', 10);
    if (!id) {
      form.submit();
      return;
    }

    var body = { items: [{ id: id, quantity: qty }] };
    var sections = sectionsToRefresh();
    if (sections) body.sections = sections;

    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function (added) {
        announce(form.getAttribute('data-ev-name'));
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  source: 'everlast-arma-equipo',
                  resource: cart,
                  data: { sections: added.sections }
                }
              })
            );
            var drawer = document.querySelector('cart-drawer-component, cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              try { drawer.open(); } catch (e) { window.location.href = '/cart'; }
            } else if (!drawer) {
              window.location.href = '/cart';
            }
          });
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      });
  }

  document.addEventListener('submit', onSubmit);
})();
